export const isCsr = () => typeof window === 'object' && typeof document === 'object';
